(function(){
  if(window.__bvcd)return;window.__bvcd=1;
  var panel=document.getElementById('bvcd-panel'),ov=document.querySelector('[data-bvcd-ov]');
  if(!panel)return;
  var root=window.Shopify&&Shopify.routes&&Shopify.routes.root||'/';
  function lock(on){document.documentElement.classList.toggle('bvcd-lock',on)}
  function open(){ov.hidden=false;requestAnimationFrame(function(){ov.classList.add('is-open');panel.classList.add('is-open')});panel.setAttribute('aria-hidden','false');lock(true);setTimeout(function(){try{panel.focus({preventScroll:true})}catch(e){}},50)}
  function close(){ov.classList.remove('is-open');panel.classList.remove('is-open');panel.setAttribute('aria-hidden','true');lock(false);setTimeout(function(){ov.hidden=true},320)}
  var busy=false;
  function refresh(openAfter){
    var wrap=panel.querySelector('.bvcd');if(wrap)wrap.classList.add('is-loading');
    return fetch(root+'?sections=bv-cart-drawer',{cache:'no-store'}).then(function(r){return r.json()}).then(function(j){
      var html=j['bv-cart-drawer'];if(!html)return;
      var tmp=document.createElement('div');tmp.innerHTML=html;
      var sec=panel.querySelector('.shopify-section')||panel;
      var inner=tmp.querySelector('.shopify-section')||tmp;
      sec.innerHTML=inner.innerHTML;
      if(openAfter)open();
    }).catch(function(){}).finally(function(){var w=panel.querySelector('.bvcd');if(w)w.classList.remove('is-loading')});
  }
  window.bvCartOpen=function(){refresh(true)};
  window.bvCartRefresh=refresh;
  function post(url,body){busy=true;return window.__bvcdFetch(root+url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)}).then(function(r){return r.json()}).finally(function(){busy=false;document.dispatchEvent(new CustomEvent('theme:cart:updated'))})}
  panel.addEventListener('click',function(e){
    var c=e.target.closest('[data-bvcd-close]');if(c){e.preventDefault();close();return}
    var q=e.target.closest('[data-bvcd-qty]');
    if(q){e.preventDefault();var li=q.closest('[data-key]');post('cart/change.js',{id:li.dataset.key,quantity:parseInt(q.dataset.bvcdQty,10)}).then(function(){refresh(false)});return}
    var a=e.target.closest('[data-bvcd-add],[data-bvcd-add-sel]');
    if(a){e.preventDefault();var id=a.dataset.bvcdAdd;if(!id){var s=a.parentElement.querySelector('select');id=s&&s.value}if(!id)return;a.textContent='Añadiendo…';post('cart/add.js',{items:[{id:+id,quantity:1}]}).then(function(){refresh(false)});}
  });
  ov.addEventListener('click',close);
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&panel.classList.contains('is-open'))close()});
  document.addEventListener('click',function(e){
    var a=e.target.closest('a[href$="/cart"],a[href="/cart"],[data-bvcd-open]');
    if(!a||panel.contains(a))return;
    if(location.pathname.replace(/\/$/,'').endsWith('/cart'))return;
    e.preventDefault();e.stopPropagation();refresh(true);
  },true);
  // abrir tras añadir al carrito
  var of=window.fetch;window.__bvcdFetch=of;
  window.fetch=function(input,init){
    var url=typeof input==='string'?input:(input&&input.url)||'';
    var p=of.apply(this,arguments);
    if(/\/cart\/add/.test(url)&&!busy){p.then(function(r){if(r.ok)setTimeout(function(){refresh(true)},250)})}
    return p;
  };
  document.addEventListener('submit',function(e){var f=e.target;if(f&&f.action&&/\/cart\/add/.test(f.action)&&!f.closest('[data-bv-quickadd]')&&!f.closest('product-form-component')){}},true);
    if(/^\/cart\/?$/.test(location.pathname)){
    var _close=close;
    close=function(){_close();location.href=root;};
    if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){refresh(true)});}else{refresh(true);}
  }

})();